import { InMemoryCacheConfig } from '@apollo/client';

/*
  This shared Apollo cache config object is used to configure the cache 
  beyond the schema that the API provides.
  
  Presently the EntityRawDataLegacy response can either return a JSON or a Text type.
  We have to instruct the introspection for the fragment to be a UNION.

  It is likely something we can handle in the server-side graphql proxy.
  But at the time of this writing, we needed to handle it on the client.
*/

const cacheConfig: InMemoryCacheConfig = {
  possibleTypes: {
    RawDataQueryPayloadLegacy: [
      'RawDataJSONEntityLegacy',
      'RawDataTextEntityLegacy',
    ],
  },
};
export default cacheConfig;
